/**
 * Created by praveenningappa on 7/6/17.
 */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Row, Col, Image } from 'react-bootstrap';
import * as LearnMoreHelper from 'app-lib/helpers/learn-more-helper';
import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

export class LearnMore extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            url: window.location.href
        };
    }

    componentDidMount() {
        PageTracker.lastPage = Page.LEARN_MORE;
    }

    setFooter() {
        const {t} = this.props;
        return (
            <section className="footer generic-page-footer lgray">
                <div className="left">
                    <span>{t('channel.footer.powered')}</span>
                </div>
                <div className="right">
                    <span>
                        <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                           {t('channel.footer.tnc')}
                        </a>
                    </span>
                    <span>
                        <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                           {t('channel.footer.privacy')}
                        </a>
                    </span>
                    <span>{t('channel.footer.copyright')} {t('channel.footer.company')}</span>
                </div>
            </section>);
    }

    getLearnMoreBanner() {
        return (
            <div className="learn-more__banner">
                <Image src={`${config.assets.url}/images/learn-more/learnmore-banner.png`} alt="banner-img" responsive />
            </div>);
    }

    getLearnMoreContent() {
        return (
            <div className="learn-more__content">
                <Row className="clearfix">
                    <Col sm={3} md={3}>
                        {this.getNavItems()}
                    </Col>
                    <Col sm={9} md={9}>
                          {this.state.url.includes('#gotostage') ? LearnMoreHelper.getGotoStageData() : null}
                          {this.state.url.includes('#aboutChannel') ? LearnMoreHelper.getAboutChannelData() : null}
                          {this.state.url.includes('#hideChannel') ? LearnMoreHelper.getHideChannelData() : null}
                          {this.state.url.includes('#addRecordings') ? LearnMoreHelper.getAddRecordingsData() : null}
                          {this.state.url.includes('#accessChannel') ? LearnMoreHelper.getAccessChannelData() : null}
                          {this.state.url.includes('#customizeChannel') ? LearnMoreHelper.getCustomizeChannelData() : null}
                          {this.state.url.includes('#shareChannel') ? LearnMoreHelper.getShareChannelData() : null}
                          {this.state.url.includes('#optimizeContent') ? LearnMoreHelper.getOptimizeContentData() : null}
                          {this.state.url.includes('#trackViews') ? LearnMoreHelper.getTrackViewsData() : null}
                          {this.state.url.includes('#askQuestions') ? LearnMoreHelper.getAskQuestionsData() : null}
                          {(this.state.url.indexOf('#') === -1) ? LearnMoreHelper.getGotoStageData() : null}
                    </Col>
                </Row>
            </div>
        );
    }

    handleClick(data) {
        this.setState({url: data.target.href});
    }

    getNavItems() {
        const {t} = this.props;
        return (
            <div className="learn-more__nav">
                <a className={this.state.url.includes('#gotostage') || (this.state.url.indexOf('#') === -1) ? 'learn-more__linkActive' : null} href="#gotostage" onClick={this.handleClick.bind(this)}>
                  GoToStage
                </a>
                <a className={this.state.url.includes('#aboutChannel') ? 'learn-more__linkActive' : null} href="#aboutChannel" onClick={this.handleClick.bind(this)}>
                  Your Channel (Beta)
                </a>
                <a className={this.state.url.includes('#hideChannel') ? 'learn-more__linkActive' : null} href="#hideChannel" onClick={this.handleClick.bind(this)}>
                  Hide channel (if needed)
                </a>
                <a className={this.state.url.includes('#addRecordings') ? 'learn-more__linkActive' : null} href="#addRecordings" onClick={this.handleClick.bind(this)}>
                  Add recordings to channel
                </a>
                <a className={this.state.url.includes('#accessChannel') ? 'learn-more__linkActive' : null} href="#accessChannel" onClick={this.handleClick.bind(this)}>
                  Access your Channel
                </a>
                <a className={this.state.url.includes('#customizeChannel') ? 'learn-more__linkActive' : null} href="#customizeChannel" onClick={this.handleClick.bind(this)}>
                  Customize your Channel
                </a>
                <a className={this.state.url.includes('#shareChannel') ? 'learn-more__linkActive' : null} href="#shareChannel" onClick={this.handleClick.bind(this)}>
                  Share your Channel
                </a>
                <a className={this.state.url.includes('#optimizeContent') ? 'learn-more__linkActive' : null} href="#optimizeContent" onClick={this.handleClick.bind(this)}>
                  Optimize your content
                </a>
                <a className={this.state.url.includes('#trackViews') ? 'learn-more__linkActive' : null} href="#trackViews" onClick={this.handleClick.bind(this)}>
                  Keep track of views
                </a>
                <a className={this.state.url.includes('#askQuestions') ? 'learn-more__linkActive' : null} href="#askQuestions" onClick={this.handleClick.bind(this)}>
                  Questions & feedback
                </a>
                <a href={`${config.app.baseUrl}/faq`} target="_blank" rel="noopener">
                    {t('learnMore.faq')}
                </a>
            </div>
          );
    }

    render() {
        return (
            <section className="body">
                <div className="learn-more__page">
                    {this.getLearnMoreBanner()}
                    {this.getLearnMoreContent()}
                    {this.setFooter()}
                </div>
            </section>
        );
    }
}

LearnMore.propTypes = {
    t: PropTypes.func
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions), dispatch)
)(translate(['translation'])(LearnMore));



// WEBPACK FOOTER //
// ./src/components/learn-more/learn-more.js